function openSAVPopup(e) {
  $("#store_av_popup").addClass("cc-popup--visible"); // Open popup
}

function closeSAVPopup(e) {
  $("#store_av_popup").removeClass("cc-popup--visible"); // Close popup
}

function getStores() {
  const apiUrl = "https://nood.gadget.app/api/locations";

  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        if (latitude && longitude) {
          checkInStoreProduct(
            `${apiUrl}?variant_id=${vID}&latitude=${latitude}&longitude=${longitude}`
          );
        }
      },
      function (error) {
        console.error("Error getting location:", error);
        checkInStoreProduct(`${apiUrl}?variant_id=${vID}`);
      }
    );
  } else {
    console.error("Geolocation is not supported by this browser");
    checkInStoreProduct(`${apiUrl}?variant_id=${vID}`);
  }
}

async function getStoreInventoryDetails(JSONurl) {
  try {
    const response = await fetch(JSONurl);
    return await response.json();
  } catch (err) {
    console.log("fetch failed", err);
  }
}

async function checkInStoreProduct(endpointURL) {
  let data = await getStoreInventoryDetails(endpointURL);
  displayStoreData(data);
}

function displayStoreData(res) {
  let availableStores = [];
  let storeWrapper = $("#store_av_popup #stores_wrapper");
  let nodes = ``;

  for (let i = 0; i < res.data.length; i++) {
    if (res.data[i].name === "NOOD PALMERSTON NORTH" || res.data[i].name.includes("WEB")) {
      continue;
    }
    let storeName = res.data[i].name.includes("WEB") ? "NOOD WAREHOUSE" : res.data[i].name; // eg. NOOD NEWMARKET
    let lowercasedStoreName = storeName.replace("NOOD ", "").replaceAll(" ", "-").toLowerCase(); // eg. newmarket

    let inventory = res.data[i].available;
    let status = "available"; // available || unavailable
    let pickupText = "Pickup available"; // Pickup available || Out of Stock || Low Stock
    let additionaClass = "";

    let address = res.data[i].address;
    let phone = res.data[i].address.phone; // eg. +6434774436

    let productTagsArr = JSON.parse($(`#cc-product-json-${pID}`).text()).tags;

    // Update text and class by inventory
    if (inventory == 0) {
      status = "unavailable";
      pickupText = "Out of Stock";
      additionaClass += " unavailable";
    } else if (inventory <= 3) {
      pickupText = "Low Stock";
      additionaClass += " low-stock";
    }

    // Update class IF display model only (product tag contains ':dmo')
    productTagsArr.forEach((tag) => {
      if (tag.includes("dmo") && tag.includes(lowercasedStoreName)) {
        pickupText = "Display model only";
        additionaClass = additionaClass.replaceAll(" unavailable", " dmo");

        availableStores.push({
          store_name: storeName,
          pickupText: pickupText,
          additionaClass: additionaClass,
        });
      }
    });

    if (inventory > 0) {
      availableStores.push({
        store_name: storeName,
        pickupText: pickupText,
        additionaClass: additionaClass,
      });
    }

    nodes += `
      <div class="store-availability-list__item ${lowercasedStoreName} ${additionaClass}" data-store="${lowercasedStoreName}">
        <div class="store-availability-list__location ">
          <div class="store-availability-list__location__text"><strong>${storeName}</strong></div>
        </div>
        <div class="store-availability-list__stock store-availability-small-text">
          <div class="cc-icon-${status}">
            <svg xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" viewBox="0 0 512 512"><path fill="currentColor" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
            <span class="svg-pickup-unavailable"><svg class="svg-pickup-unavailable" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" viewBox="0 0 352 512"><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg></span>
          </div>
          <small>${pickupText}</small>
        </div>
        <address class="store-availability-list__address sa sa-custom"><span>${address.address1}</span><span>${address.address2}</span><span>${address.province} ${address.zip}</span><span>${address.country}</span></address>
        <p class="store-availability-list__phone store-availability-list__phone--mobile"><a href="tel:${phone}">${phone}</a><br></p>
        <p class="store-availability-list__phone store-availability-list__phone--desktop">${phone}<br></p>
      </div>
    `;
  }

  displayStorePDPsnippet(availableStores);

  storeWrapper.empty().html(nodes);
  $("#store_av_popup .loading_wrapper").addClass("hide");
}

function displayStorePDPsnippet(availableStores) {
  let storeSnippet = $(
    ".store-availability-container-outer.sa_snippets .store-availability-information"
  );
  let closestStore = storeSnippet.attr("data-closest");

  if (availableStores.length > 0) {
    // Available store exist
    availableStores.sort((a, b) => {
      if (a.pickupText === "Pickup available" && b.pickupText !== "Pickup available") {
        return -1;
      }
      if (a.pickupText !== "Pickup available" && b.pickupText === "Pickup available") {
        return 1;
      }
      return 0;
    });
    // Add class
    storeSnippet
      .find(".store-availability-icon")
      .removeClass("store-availability-icon--unavailable")
      .addClass("store-availability-icon--available");

    // Add attribute data
    let lowercasedStoreName = availableStores[0].store_name
      .replace("NOOD ", "")
      .replaceAll(" ", "-")
      .toLowerCase(); // eg. newmarket
    storeSnippet.find(".store-availability-icon").attr("data-store", lowercasedStoreName);

    // Find first available store and replace text
    if (!closestStore || closestStore != availableStores[0].store_name) {
      let modifiedPickupText = "Pickup available at";

      if (availableStores[0].pickupText.includes("Display")) {
        modifiedPickupText = "Display model available to view at ";
        storeSnippet.find(".store-availability-icon").addClass(" dmo");
      } else if (availableStores[0].pickupText.includes("Low")) {
        storeSnippet.find(".store-availability-icon").addClass(" low-stock");
      }

      $(".store-availability-information__title span")
        .empty()
        .html(`${modifiedPickupText} <strong>${availableStores[0].store_name}</strong>`);
    }
  } else {
    // All stores are unavailable.
    storeSnippet.hide();
    // storeSnippet.find('.store-availability-icon').removeClass('store-availability-icon--available').addClass('store-availability-icon--unavailable')
    // $('.store-availability-information__title span').empty().html(`Pickup currently unavailable`)
  }

  // console.log('available Stores: ', availableStores)
  $(".store-availability-container .loading_wrapper").addClass("hide");
}
document.addEventListener("DOMContentLoaded", async (event) => {
  try {
    const productForm = document.querySelector(".section-product-template .product-purchase-form");
    if (productForm) {
      const submitButton = productForm.querySelector("button[type='submit']");
      submitButton.classList.add("disabled");
      const stores = await getAvailableForPickupStores(vID);
      const inputValue = [];
      stores.forEach((store) => {
        inputValue.push({
          store_name: store.name.includes("WEB") ? "NOOD WAREHOUSE" : store.name,
          available: store.available,
        });
      });
      const hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = "properties[_available_for_pickup_stores]";
      hiddenInput.value = JSON.stringify(inputValue);
      productForm.appendChild(hiddenInput);
      console.log("finished");
      submitButton.classList.remove("disabled");
    }
  } catch (error) {
    console.error("Error processing store availability:", error);
  }
  getStores();
});
